import { IconName, IconSize } from '@ardoq/icons';
import { ARDOQ_DEFAULT_FONT_FAMILY } from '@ardoq/typography';
import { colors } from '@ardoq/design-tokens';
import { SpaceVariant } from '@ardoq/layout';
import { InternalBreadcrumbsProps } from './types';

export const defaultProps: InternalBreadcrumbsProps = {
  breadcrumbs: [],
  ellipsis: '...',
  leadingIcon: {
    name: IconName.FOLDER,
    size: IconSize.SMALL,
    rightMargin: 'xsmall' as SpaceVariant,
  },
  dividerIcon: {
    name: IconName.CHEVRON_RIGHT,
    size: IconSize.SMALL,
  },
  textStyles: {
    fontFamily: ARDOQ_DEFAULT_FONT_FAMILY,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    color: colors.textSubtle,
  },
};
